export default {
      id: "human-usage",
      viewBox: "0 0 24 66",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#human",
      toString: function () {
        return this.url;
      }
    }